import { render, staticRenderFns } from "./issueRegister.vue?vue&type=template&id=7aad188c&scoped=true"
import script from "./issueRegister.vue?vue&type=script&lang=js"
export * from "./issueRegister.vue?vue&type=script&lang=js"
import style0 from "./issueRegister.vue?vue&type=style&index=0&id=7aad188c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aad188c",
  null
  
)

export default component.exports